<script lang="ts">
    import { useLocation } from "./context";

    const { childrens, component, path } = $props<{ path: string, component?: any }>();
    const { location } = useLocation();
</script>

{#if path === location?.path}
    {#if (component)}
        {@render component?.()}
    {:else}
        {@render childrens?.()}
    {/if}
{/if}